import "./index.scss";

import React from "react";

import { useAppStore } from "../../../stores";

type NavMenuItem = {
	_id: string;
	displayName: string;
	modifiedTime?: string;
	data: {
		link: string;
		contentTypeImage?: string;
		contentTypeImageAltText?: string;
		parentItem?: string;
		groups?: string;
		categoryLink?: string;
	};
	children?: NavMenuItem[];
	_name?: string;
};

type NavMenuList = NavMenuItem[];

interface HeaderBottomProps {
	navMenuList?: NavMenuList | null;
}
export default function Component({ navMenuList }: HeaderBottomProps) {
	const appStore = useAppStore((state) => state);

	const safeNavMenuList: NavMenuList = Array.isArray(navMenuList) ? navMenuList : [];

	const getPublishTime = (item: NavMenuItem): number => {
		const date = item.modifiedTime ?? "1970-01-01T00:00:00.000Z";
		return new Date(date).getTime();
	};

	const sortedNavMenuList = [...safeNavMenuList].sort((a, b) => getPublishTime(b) - getPublishTime(a));

	return (
		<div className="header-bottom">
			<div className="container">
				<div className="bottom-wrapper">
					<a className="logo col-12 col-md-4" href={appStore.sitePath?.[0].link ?? ""}>
						<img
							src={appStore.siteData?.logo}
							srcSet={appStore.siteData?.logoSrcset}
							sizes="(max-width: 768px) 180px, 360px"
							alt={appStore.phrases?.["logo"]}
							loading="lazy"
						/>
						<div>
							<h6>{appStore.siteData?.logoTitle}</h6>
						</div>
					</a>

					<div className="d-none d-md-block col-md-8">
						<nav className="nav-wrapper">
							{Array.isArray(sortedNavMenuList) && sortedNavMenuList.length > 0 ? (
								sortedNavMenuList.map((item) => (
									<div key={item._id} className="nav-block position-relative">
										{item.children && item.children.length > 0 ? (
											<div className="nav-item dropdown">
												<a
													className="nav-link"
													href={item.data.link}
													role="button"
													data-bs-toggle="dropdown"
													aria-expanded="false"
												>
													<h5 className="m-0">{item.displayName}</h5>
												</a>

												<ul className="dropdown-menu">
													{item.children.map((child) => (
														<li key={child._id}>
															<a
																className={`dropdown-item ${appStore.currentPage === child.data.link ? "active" : ""}`}
																href={`${item.data.link}?category=${child.data.categoryLink}`}
															>
																{child.displayName}
															</a>
														</li>
													))}
												</ul>
											</div>
										) : (
											<a
												className={`nav-link ${appStore.currentPage === item.data.link ? "active" : ""}`}
												href={item.data.link}
											>
												<h5 className="m-0">{item.displayName}</h5>
											</a>
										)}
									</div>
								))
							) : (
								<div className="empty">
									<h3>{appStore.phrases?.["empty"]}</h3>
								</div>
							)}
						</nav>
					</div>
				</div>
			</div>
		</div>
	);
}
